import { getToken } from "./storage"; //updateUserLogin

export const inactiveSessionKey = 'lastInactiveTime';
export const logoutSyncKey = "crm-logout-sync";

const MAXIMUM_INACTIVE_TIME = Number(window._env_?.REACT_APP_MAXIMUM_INACTIVE_TIME || process.env.REACT_APP_MAXIMUM_INACTIVE_TIME) || 15 * 60 * 1000;
const CHECK_INTERVAL = 5000;

const setLastTime = () => {
  window.localStorage.setItem(inactiveSessionKey, Date.now().toString());
};
const forceLogout = () => {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem(inactiveSessionKey);
  window.localStorage.setItem(logoutSyncKey, Date.now().toString());
  window.location.href = "/logout";
};

const checkInactivity = () => {
  const token = getToken();
  const lastInactiveTime = Number(
    window.localStorage.getItem(inactiveSessionKey)
  );

  if (!token) {
    forceLogout();
    return;
  }

  if (!lastInactiveTime) {
    setLastTime();
    return;
  }

  const diff = Date.now() - lastInactiveTime;

  if (diff > MAXIMUM_INACTIVE_TIME) {
    console.log("⏱ Auto Logout Triggered");
    forceLogout();
  }
};
export const autoLogout = () => {

  if (!window.localStorage.getItem(inactiveSessionKey)) {
    setLastTime();
  }
 checkInactivity();

  const handleUserActivity = () => {
    setLastTime();
  };

  const events = ["mousedown","keypress","touchstart","click","scroll","mousemove"];

  events.forEach((event) =>
    window.addEventListener(event, handleUserActivity)
  );

  const intervalId = setInterval(checkInactivity, CHECK_INTERVAL);

  const handleTabFocus = () => {
    if (document.visibilityState === "visible") {
      checkInactivity();
    }
  };

  document.addEventListener("visibilitychange", handleTabFocus);
  window.addEventListener("focus", handleTabFocus);

  const handleStorage = (e) => {
    if (e.key === logoutSyncKey) {
      forceLogout();
    }
  };

  window.addEventListener("storage", handleStorage);

  return () => {
    events.forEach((event) =>
      window.removeEventListener(event, handleUserActivity)
    );
    document.removeEventListener("visibilitychange", handleTabFocus);
    window.removeEventListener("focus", handleTabFocus);
    window.removeEventListener("storage", handleStorage);
    clearInterval(intervalId);
  };
};
